import React, { useCallback } from 'react'
import MarkdownRender from 'LuxKit/MarkdownRender'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import FlashHotelAvailabilityButton from '../FlashHotelAvailabilityButton'
import SoftOfferPageWalledGarden from 'components/Common/SoftOfferPageWalledGarden'

interface Props {
  descriptionMarkdown: string;
  facilitiesMarkdown?: string;
}

function FlashHotelAboutHotelModal(props: Props) {
  const {
    descriptionMarkdown,
    facilitiesMarkdown,
  } = props

  const { resolve } = useModalElementContext()
  const onCTAClick = useCallback(() => resolve(), [resolve])

  return (
    <ModalBase>
      <ModalHeader title="About the hotel" />
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={24}>
            <MarkdownRender type="compact" content={descriptionMarkdown} />
            {facilitiesMarkdown && <>
              <HeadingTextBlock variant="heading4">
                Hotel Facilities
              </HeadingTextBlock>
              <MarkdownRender type="compact" fontSize="large" content={facilitiesMarkdown} />
            </>}
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
      <SoftOfferPageWalledGarden>
        <ModalFooter>
          <FlashHotelAvailabilityButton onClick={onCTAClick} />
        </ModalFooter>
      </SoftOfferPageWalledGarden>
    </ModalBase>
  )
}

export default FlashHotelAboutHotelModal
